import React, { FC } from 'react'
import { LegalContents } from '@chegg-wt/core/types/core'
import * as Styled from './styled'

interface LegalNodeProps {
  contents: LegalContents
}

export const LegalNode: FC<LegalNodeProps> = ({ contents }) => (
  <Styled.BorderContainer>
    <Styled.LegalWrapper>
      {contents.commitment ? (
        <Styled.Commitment>
          <Styled.Text size="xs" color="grey76">
            {contents.commitment}
          </Styled.Text>
        </Styled.Commitment>
      ) : null}
      <Styled.ContentContainer>
        <Styled.Text size="xs" color="grey76">
          {contents.copyright}
        </Styled.Text>
      </Styled.ContentContainer>
      <Styled.ContentContainer>
        <Styled.Text size="xs" color="grey76">
          {contents.tagline}
        </Styled.Text>
      </Styled.ContentContainer>
    </Styled.LegalWrapper>
  </Styled.BorderContainer>
)
